// Mock data for BPC — Business Performance Consulting (BCG-style, SAP blue/silver theme)

export const navItems = [
  { label: "Insights", path: "/insights" },
  { label: "Capabilities", path: "/capabilities" },
  { label: "Magazine", path: "/magazine" },
  { label: "BLounge", path: "/blounge" },
  { label: "About", path: "/about" },
  { label: "Contact", path: "/contact" },
];

export const heroSlides = [
  {
    id: "h1",
    eyebrow: "Growth Strategy",
    title: "Turning marketing ambition into measurable growth",
    excerpt:
      "How the world's most resilient brands are rebuilding demand engines around data, creativity, and speed.",
    image:
      "https://images.unsplash.com/photo-1560179707-f14e90ef3623?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwxfHxjb3Jwb3JhdGUlMjBjb25zdWx0aW5nfGVufDB8fHx8MTc4NzM4OTY3OHww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "h2",
    eyebrow: "Business Development",
    title: "The playbook for entering markets that matter",
    excerpt:
      "A disciplined approach to prioritising opportunities and scaling what works.",
    image:
      "https://images.pexels.com/photos/7698796/pexels-photo-7698796.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "h3",
    eyebrow: "Digital Marketing",
    title: "Precision marketing in the age of AI",
    excerpt:
      "Rethinking the operating model to deliver personalisation at scale.",
    image:
      "https://images.unsplash.com/photo-1557838923-2985c318be48?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwzfHxkaWdpdGFsJTIwbWFya2V0aW5nfGVufDB8fHx8MTc4NzM4OTcwNnww&ixlib=rb-4.1.0&q=85",
  },
];

export const insights = [
  {
    id: "i1",
    category: "Marketing Strategy",
    title: "Building a demand engine that compounds",
    excerpt:
      "Leaders who connect brand and performance marketing outgrow peers by double digits.",
    image:
      "https://images.unsplash.com/photo-1519389950473-47ba0277781c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHxkaWdpdGFsJTIwbWFya2V0aW5nfGVufDB8fHx8MTc4NzM4OTcwNnww&ixlib=rb-4.1.0&q=85",
    date: "July 2025",
    readTime: "8 min read",
  },
  {
    id: "i2",
    category: "Data & Analytics",
    title: "From dashboards to decisions: the analytics dividend",
    excerpt:
      "Why measurement maturity is the strongest predictor of marketing ROI.",
    image:
      "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxkYXRhJTIwYW5hbHl0aWNzfGVufDB8fHx8MTc4NzM4OTcwNnww&ixlib=rb-4.1.0&q=85",
    date: "June 2025",
    readTime: "6 min read",
  },
  {
    id: "i3",
    category: "Business Development",
    title: "Winning the next market: a prioritisation framework",
    excerpt:
      "A structured way to size, sequence, and scale expansion opportunities.",
    image:
      "https://images.unsplash.com/photo-1591696205602-2f950c417cb9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwzfHxncm93dGglMjBjaGFydHxlbnwwfHx8fDE3ODczODk3MDZ8MA&ixlib=rb-4.1.0&q=85",
    date: "June 2025",
    readTime: "10 min read",
  },
  {
    id: "i4",
    category: "Customer Experience",
    title: "The loyalty economics of exceptional CX",
    excerpt:
      "Experience leaders convert satisfaction into durable revenue growth.",
    image:
      "https://images.pexels.com/photos/7651801/pexels-photo-7651801.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    date: "May 2025",
    readTime: "7 min read",
  },
  {
    id: "i5",
    category: "Technology",
    title: "Reinventing the marketing operating model with AI",
    excerpt:
      "How to embed generative AI without losing brand control.",
    image:
      "https://images.unsplash.com/photo-1666875753105-c63a6f3bdc86?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxkYXRhJTIwYW5hbHl0aWNzfGVufDB8fHx8MTc4NzM4OTcwNnww&ixlib=rb-4.1.0&q=85",
    date: "May 2025",
    readTime: "9 min read",
  },
  {
    id: "i6",
    category: "Sustainability",
    title: "Growth with purpose: the sustainable brand advantage",
    excerpt:
      "Purpose-led propositions are outperforming on both trust and margin.",
    image:
      "https://images.pexels.com/photos/7876379/pexels-photo-7876379.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    date: "April 2025",
    readTime: "5 min read",
  },
];

export const capabilities = [
  {
    id: "c1",
    title: "Marketing Strategy",
    description:
      "Positioning, portfolio and go-to-market strategies that build brands and drive demand.",
  },
  {
    id: "c2",
    title: "Business Development",
    description:
      "Market entry, partnerships and commercial models that unlock new revenue.",
  },
  {
    id: "c3",
    title: "Digital & Performance",
    description:
      "Full-funnel digital marketing engineered for measurable, compounding returns.",
  },
  {
    id: "c4",
    title: "Data & Analytics",
    description:
      "Measurement, attribution and decision science that turn data into growth.",
  },
  {
    id: "c5",
    title: "Customer Experience",
    description:
      "Journey design and CX transformation that convert loyalty into revenue.",
  },
  {
    id: "c6",
    title: "Brand & Creative",
    description:
      "Distinctive brand systems and creative platforms that stand out and scale.",
  },
];

export const stats = [
  { value: "20+", label: "Years of impact" },
  { value: "600+", label: "Engagements delivered" },
  { value: "35", label: "Markets served" },
  { value: "98%", label: "Client return rate" },
];

export const magazineFeatures = [
  {
    id: "m1",
    issue: "Issue 12",
    title: "The New Growth Agenda",
    excerpt:
      "Inside the strategies redefining how ambitious companies create demand.",
    image:
      "https://images.pexels.com/photos/7688106/pexels-photo-7688106.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "m2",
    issue: "Perspective",
    title: "Leadership in an era of constant reinvention",
    excerpt: "Conversations with executives navigating disruption.",
    image:
      "https://images.unsplash.com/photo-1573164574511-73c773193279?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwyfHxkaXZlcnNlJTIwYnVzaW5lc3MlMjB0ZWFtfGVufDB8fHx8MTc4NzM4OTc0MHww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "m3",
    issue: "Field Notes",
    title: "What great marketing organisations do differently",
    excerpt: "Lessons from the highest-performing marketing teams.",
    image:
      "https://images.pexels.com/photos/36765732/pexels-photo-36765732.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export const leaders = [
  {
    id: "l1",
    name: "Emma Carter",
    role: "Managing Partner",
    image:
      "https://images.unsplash.com/photo-1580489944761-15a19d654956?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdHxlbnwwfHx8fDE3ODczODk3NDB8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "l2",
    name: "Marcus Reid",
    role: "Partner, Growth Strategy",
    image:
      "https://images.pexels.com/photos/37148308/pexels-photo-37148308.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export const aboutImages = {
  hero:
    "https://images.unsplash.com/photo-1554469384-e58fac16e23a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwzfHxjb3Jwb3JhdGUlMjBidWlsZGluZ3xlbnwwfHx8fDE3ODczODk3Mzl8MA&ixlib=rb-4.1.0&q=85",
  team:
    "https://images.pexels.com/photos/8068807/pexels-photo-8068807.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  collab:
    "https://images.pexels.com/photos/7698712/pexels-photo-7698712.jpeg?auto=compress&cs=srgb&dpr=2&h=650&w=940",
  office:
    "https://images.unsplash.com/photo-1497366811353-6870744d04b2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBvZmZpY2V8ZW58MHx8fHwxNzg3Mzg5Njc3fDA&ixlib=rb-4.1.0&q=85",
};

export const officeLocations = [
  { city: "Stockholm", address: "Kungsgatan 12, 111 43" },
  { city: "London", address: "20 Fenchurch Street, EC3M" },
  { city: "Dubai", address: "DIFC, Gate District 4" },
  { city: "Singapore", address: "Marina Bay Financial Centre" },
];

// Social profiles (update handles when real accounts are live)
export const socialLinks = {
  instagram: "https://instagram.com/bpc.consulting",
  linkedin: "https://linkedin.com/company/bpc-consulting",
  twitter: "https://x.com/bpc_consulting",
  youtube: "https://youtube.com/@bpc-consulting",
};

export const instagramHandle = "@bpc.consulting";

export const instagramPosts = [
  { id: "ig1", image: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwzfHxidXNpbmVzcyUyMHRlYW18ZW58MHx8fHwxNzg3NDA0MDY4fDA&ixlib=rb-4.1.0&q=85", caption: "Strategy day with the growth team.", likes: 428, comments: 24 },
  { id: "ig2", image: "https://images.unsplash.com/photo-1531058020387-3be344556be6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxvZmZpY2UlMjBldmVudHxlbnwwfHx8fDE3ODc0MDQwNjh8MA&ixlib=rb-4.1.0&q=85", caption: "On stage at the BPC Growth Summit.", likes: 612, comments: 41 },
  { id: "ig3", image: "https://images.pexels.com/photos/7693692/pexels-photo-7693692.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", caption: "Turning data into decisions.", likes: 351, comments: 18 },
  { id: "ig4", image: "https://images.unsplash.com/photo-1515169067868-5387ec356754?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwyfHxvZmZpY2UlMjBldmVudHxlbnwwfHx8fDE3ODc0MDQwNjh8MA&ixlib=rb-4.1.0&q=85", caption: "Culture is a strategy too.", likes: 489, comments: 32 },
  { id: "ig5", image: "https://images.unsplash.com/photo-1600880292089-90a7e086ee0c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHw0fHxidXNpbmVzcyUyMHRlYW18ZW58MHx8fHwxNzg3NDA0MDY4fDA&ixlib=rb-4.1.0&q=85", caption: "Better together — one standard: excellence.", likes: 537, comments: 29 },
  { id: "ig6", image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMHRlYW18ZW58MHx8fHwxNzg3NDA0MDY4fDA&ixlib=rb-4.1.0&q=85", caption: "The markets that matter.", likes: 704, comments: 55 },
];

// ---- HBR-style Magazine data ----
export const magazineIssue = {
  label: "July\u2013August 2025",
  title: "The Growth Issue",
  blurb:
    "Our latest issue explores how the boldest companies are turning marketing and business development into engines of durable growth.",
  cover:
    "https://images.pexels.com/photos/7688106/pexels-photo-7688106.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const caseStudies = [
  {
    id: "cs1",
    company: "Nordic Retail Group",
    title: "Rebuilding a demand engine after a market shock",
    topic: "Marketing Strategy",
    excerpt:
      "How a legacy retailer rebuilt its funnel and recovered 22% of lost demand in nine months.",
    image:
      "https://images.pexels.com/photos/7651801/pexels-photo-7651801.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "cs2",
    company: "Helix Health",
    title: "Entering three new markets without diluting the brand",
    topic: "Business Development",
    excerpt:
      "A prioritisation framework that turned scattered expansion bets into a focused, funded roadmap.",
    image:
      "https://images.unsplash.com/photo-1591696205602-2f950c417cb9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwzfHxncm93dGglMjBjaGFydHxlbnwwfHx8fDE3ODczODk3MDZ8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "cs3",
    company: "Meridian Bank",
    title: "From dashboards to decisions: an analytics turnaround",
    topic: "Data & Analytics",
    excerpt:
      "Rewiring measurement so every marketing dollar was traceable to revenue.",
    image:
      "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxkYXRhJTIwYW5hbHl0aWNzfGVufDB8fHx8MTc4NzM4OTcwNnww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "cs4",
    company: "Atlas Mobility",
    title: "Designing a CX that pays for itself",
    topic: "Customer Experience",
    excerpt:
      "Journey redesign that lifted retention 14 points and unlocked upsell revenue.",
    image:
      "https://images.pexels.com/photos/8204311/pexels-photo-8204311.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export const podcasts = [
  {
    id: "p1",
    episode: "Ep. 48",
    title: "The new rules of brand and performance marketing",
    guest: "with Emma Carter",
    duration: "32 min",
  },
  {
    id: "p2",
    episode: "Ep. 47",
    title: "How AI is rewiring the marketing operating model",
    guest: "with Marcus Reid",
    duration: "28 min",
  },
  {
    id: "p3",
    episode: "Ep. 46",
    title: "Choosing the right markets to win",
    guest: "with the BPC Growth team",
    duration: "41 min",
  },
  {
    id: "p4",
    episode: "Ep. 45",
    title: "Turning loyalty into durable revenue",
    guest: "with Atlas Mobility's CMO",
    duration: "36 min",
  },
];

export const magazineTopics = [
  "Strategy",
  "Marketing",
  "Leadership",
  "Data & AI",
  "Customer Experience",
];

// ---- BLounge (premium members) data ----
export const membershipTiers = [
  {
    id: "t1",
    name: "Member",
    price: "$49",
    cadence: "/month",
    highlight: false,
    features: [
      "Monthly group coaching",
      "Preparation material library",
      "Access to 3 growth tools",
      "Member community",
    ],
  },
  {
    id: "t2",
    name: "Premium",
    price: "$149",
    cadence: "/month",
    highlight: true,
    features: [
      "Everything in Member",
      "2x 1:1 coaching sessions / month",
      "Full tool suite unlocked",
      "Priority session booking",
      "Downloadable playbooks",
    ],
  },
  {
    id: "t3",
    name: "Enterprise",
    price: "Custom",
    cadence: "",
    highlight: false,
    features: [
      "Team coaching cohorts",
      "Dedicated growth advisor",
      "Custom tool configuration",
      "Quarterly strategy reviews",
    ],
  },
];

export const coachingSessions = [
  {
    id: "co1",
    type: "1:1 Coaching",
    title: "Marketing Strategy Deep-Dive",
    coach: "Emma Carter",
    length: "60 min",
    premium: true,
    image:
      "https://images.unsplash.com/photo-1580489944761-15a19d654956?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdHxlbnwwfHx8fDE3ODczODk3NDB8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "co2",
    type: "Group Session",
    title: "Building a Demand Engine (Cohort)",
    coach: "Marcus Reid",
    length: "90 min",
    premium: false,
    image:
      "https://images.pexels.com/photos/8068807/pexels-photo-8068807.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "co3",
    type: "1:1 Coaching",
    title: "Market Entry & Business Development",
    coach: "Emma Carter",
    length: "60 min",
    premium: true,
    image:
      "https://images.pexels.com/photos/7698712/pexels-photo-7698712.jpeg?auto=compress&cs=srgb&dpr=2&h=650&w=940",
  },
];

export const prepMaterials = [
  {
    id: "pm1",
    kind: "Playbook",
    title: "The Growth Diagnostic Toolkit",
    desc: "A 32-page workbook to pressure-test where your growth really comes from.",
    premium: true,
  },
  {
    id: "pm2",
    kind: "Template",
    title: "Go-to-Market Canvas",
    desc: "Plan positioning, channels, and metrics on a single page.",
    premium: false,
  },
  {
    id: "pm3",
    kind: "Guide",
    title: "Marketing ROI Measurement Guide",
    desc: "Attribution models and dashboards that connect spend to revenue.",
    premium: true,
  },
  {
    id: "pm4",
    kind: "Checklist",
    title: "Market Entry Readiness Checklist",
    desc: "40 questions to answer before you enter a new market.",
    premium: false,
  },
];

export const memberTools = [
  {
    id: "tool2",
    name: "Growth Readiness Score",
    desc: "Rate your organisation across 5 dimensions and get an instant score.",
    premium: false,
  },
  {
    id: "tool3",
    name: "Channel Mix Planner",
    desc: "Allocate budget across channels and visualise expected reach.",
    premium: true,
  },
  {
    id: "tool4",
    name: "Playbook Builder",
    desc: "Assemble a custom growth playbook from proven BPC modules.",
    premium: true,
  },
];
